import { CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared';

import { LoginComponent, loginState } from './';

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild([ loginState ])
  ],
  declarations: [
    LoginComponent
  ],
  entryComponents: [
  ],
  providers: [
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts